/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/22/21
 */

const getEnvType = () => {
	let envType: "prod"|"staging"|"dev" = 'prod';
	if (window.location.hostname.includes(".staging.")) envType = 'staging';
	else if (window.location.hostname.includes(".dev.")) envType = 'dev';
	else if (process.env.NODE_ENV === "development") envType = 'dev';
	return envType;
}

export const getDataUrl = (protocol: "http"|"ws" = "http") => {
	const envType = getEnvType();
	let url = `${protocol}s://vega.${envType}.atl-paas.net`;
	if (process.env.NODE_ENV === 'development') {
		url = protocol +  '://localhost:8280';
	}
	return url;
}

export const envType = getEnvType();